export default __webpack_public_path__ + "static/video-placeholder-20c2dd5e8093655636700d07f3ca560c.jpg";